import { getRoles, getDepartments, getEmployees } from '../../plugins/apiyh'
import { mapState, mapMutations } from 'vuex'

export default {
  data() {
    return {
      visibleDialog: false,
      searchVal: "",
      activeName: "1",
      departments: {},
      roles: [],
      loading: true
    }
  },
  computed: {
    ...mapState(['projectId']),
  },
  methods: {
    async getRoleList() {
      let roles = await getRoles(this.projectId)
      this.roles = roles;
    },
    async getDepartmentList(parentId = 0) {
      this.loading = true;
      let data = await getDepartments(parentId, this.projectId);
      this.loading = false;
      this.departments = data;
    },
    getDebounceData(event, type = 1) {
      this.$func.debounce(async function () {
        if (event.target.value) {
          // let data = {
          //   searchName: event.target.value
          // }
          if (type == 1) {
            this.departments.childDepartments = [];
            let res = await getEmployees(0, this.projectId, event.target.value);
            this.departments.employees = res
          } else {
            let res = await getRoles(this.projectId, event.target.value)
            this.roles = res
          }
        } else {
          type == 1 ? await this.getDepartmentList() : await this.getRoleList();
        }
      }.bind(this))()
    },
  }
}
